// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7 2C4.79086 2 3 3.79086 3 6V18C3 20.2091 4.79086 22 7 22H21V2H7ZM11 5H18V7H11V5ZM5 18C5 16.8954 5.89543 16 7 16H19V20H7C5.89543 20 5 19.1046 5 18Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-book-filled')
export default class BookFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'book-filled',
    }
  }
}
